import React from 'react';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import './WhatsAppButton.css';

const WhatsAppButton = () => {
  const phoneNumber = "447578513420"; // UK number in international format
  const message = "Hello! I'm interested in your web development services.";
  
  const handleWhatsAppClick = () => {
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <motion.div 
      className="whatsapp-button"
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      transition={{ duration: 0.3, delay: 1 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
    >
      <button 
        onClick={handleWhatsAppClick}
        className="whatsapp-btn"
        aria-label="Contact us on WhatsApp"
      >
        <FontAwesomeIcon icon={faWhatsapp} />
        <span className="whatsapp-text">WhatsApp</span>
      </button>
    </motion.div>
  );
};

export default WhatsAppButton;